import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PreSubmitIssue } from './agent.service';

@Injectable({ providedIn: 'root' })
export class FieldIssueService {
  private issuesSubject = new BehaviorSubject<PreSubmitIssue[]>([]);
  readonly issues$ = this.issuesSubject.asObservable();

  setIssues(issues: PreSubmitIssue[]): void {
    this.issuesSubject.next(issues);
  }

  clearIssues(): void {
    this.issuesSubject.next([]);
  }
}
